// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 960) return "static/chunks/960-baeae99f1a1d9ee5.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"56":"3258d776e751ad0f","907":"61df6391ef114358"}[chunkId] + ".js";
};